import {Component} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {AuthentService} from "../../../services/authent.service";
import {User} from "../../../model/user";
import {UserService} from "../../../services/data/user.service";
import {Environment} from "../../../configuration/environment";
import {ConfigurationService} from "../../../services/configuration.service";
import {Location} from "@angular/common";
import {CurrentBusinessService} from "../../../services/communication/currentBusinessService";

@Component({
  selector: 'order-account',
  template: require('./order-account.component.html'),
  styles: [
    require('./order-account.component.scss')
  ]
})
export class OrderAccountComponent {

  type: string;

  orderType: string = 'buy';

  length: string = 'month';

  itemType: string = '';

  principal: User;

  env: Environment;

  validated: boolean = false;

  businessId: number;

  constructor(private activatedRoute: ActivatedRoute,
              private authent: AuthentService,
              private userService: UserService,
              private conf: ConfigurationService,
              private location: Location, private currentBusiness: CurrentBusinessService) {
    this.env = conf.env;
    this.businessId = this.currentBusiness.getBusiness().id;

    this.principal = this.authent.getUser();

    if (this.principal == null) {
      this.authent.loggedIn$.subscribe(logged => {
        if(logged) {
          this.principal = this.authent.getUser();
        }
      });
    }

    this.activatedRoute.params.subscribe(
      (param: any) => {
        this.type = param['type'];
        this.updateItemType();
      });
  }

  selectChangeLength(length: string) {
    this.length = length;
    this.updateItemType();
  }

  changeOrderType(type: string) {
    this.orderType = type;
    this.updateItemType();
  }

  updateItemType() {
    this.itemType = this.type + '-' + this.length + '-' + this.orderType;
  }

  validateChoice() {
    this.validated = true;
  }

  back() {
    this.location.back();
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/premium/order-account/order-account.component.ts